module.exports = __webpack_public_path__ + "static/media/1625002574550.f0ae36ef.jfif";